exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-wrapper[data-v-58a4f7ab]{background-color:hsla(214,5%,74%,.05)!important;padding:10px 0!important;border-radius:8px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58a4f7ab","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/office/js/components/dashboard-v5/start-a-project/index.vue
// module id = v/sb
// module chunks = 0